//system
import { Injectable } from '@angular/core';

//services
import { ApiRequestService } from "../services/api-request.service";
import { MapRendererService } from './map-renderer.service';
import { RenderAndPreviewControllerService } from './render-and-preview-controller.service';
import { DisplayMessageToUserService } from './display-to-user-message.service';
import { ClearDataService } from "../services/clear-data.service";


@Injectable({
  providedIn: 'root'
})
export class UserInputParserService {


  private digitsCheck = new RegExp('^[0-9]+');
  private lattersUACheck = /^[абвгґдежзийклмнопрстуфхцчшщьюяіїєІЇЄ'` АБВГҐДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЮЯ-]+$/    // /^[а-яієїґ\']+$/ig  // /[А-ЯЄI][а-яєi]+/g //("/[а-яієїґ\']/gi")


  constructor(
    private API: ApiRequestService,
    private map: MapRendererService,
    private controller: RenderAndPreviewControllerService,
    private displayMessage: DisplayMessageToUserService,
    private clear: ClearDataService
  ) { }

  private lastValidUsersInput;

  updateUsersInput(newWord: string) {
    if (newWord && newWord.length >= 2 && newWord.length !== 0 && (this.digitsCheck.test(newWord) || this.lattersUACheck.test(newWord))) {
      // check length and only digits or only latters
      newWord = newWord.trim();
      this.lastValidUsersInput = newWord;
      if (this.digitsCheck.test(newWord) && newWord.length == 5) {  // if index inputed
        this.controller.byIndex(newWord);
        this.clear.emitClearObjectOptional({ Dropdown: true })
        return;
      }// index search

      if (this.lattersUACheck.test(newWord) && newWord.length > 1) {
        // search for cities
        this.API.sendRequestForCitiesByPrefix(newWord);
        this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true });
        return;
      }// cities search

      // if no return executed input not valid
      //let message = this.displayMessage.getCurrentLang().errors.validSymbolsForInput;
      //this.displayMessage.displayMessageOnMap(true, message);
    } else {
      // word not valid
      let message = this.displayMessage.getCurrentLang().errors.validSymbolsForInput;
      this.displayMessage.displayMessageOnMap(true, message);
      this.clear.emitClearObjectOptional({ Map: true, Dropdown: true, previewList: true, previewSelected: true }) // , clearMapMessage: 
      this.map.hidePreview()
    }

  }

  public getLastValidUsersInput() {
    return this.lastValidUsersInput;
  }

}
